module.exports = __webpack_public_path__ + "pa.f04e2db86d8202d49462.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pa.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pa.svg
// module chunks = styles